import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2b52173f: FaireBrandEntity = {
  token: "b_2b52173f",
  type: "brand",
  name: "Camellia Sinensis",
  avatarUrl:
    "https://cdn.faire.com/fastly/aa974364042d4d8707130276499dcddcfe21c048103ccb745e2dd4de86f4ccd8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c5dfbfd9e8803e3ed62ced73256f082b6cc519ec44a156c1854d37249294e24.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aa974364042d4d8707130276499dcddcfe21c048103ccb745e2dd4de86f4ccd8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c5dfbfd9e8803e3ed62ced73256f082b6cc519ec44a156c1854d37249294e24.jpeg",
  location: "Montreal, QC, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isInsider: false,
  description:
    "The core of our company is a group of four professional tea-tasters, each specializing in a different tea-growing region of Asia. Every Spring since 1998, we travel to the tea gardens to select the premium leaves that make up our World famous catalogue. Discover the fresh taste our authentic and original teas have to offer.",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:20:58.341Z",
    importedBy: "entity-db-cli",
  },
};
